/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CaseFileType {
    Produceable = 0,
    Pleading = 1
}

export function CaseFileTypeFromJSON(json: any): CaseFileType {
    return CaseFileTypeFromJSONTyped(json, false);
}

export function CaseFileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileType {
    return json as CaseFileType;
}

export function CaseFileTypeToJSON(value?: CaseFileType | null): any {
    return value as any;
}

